import { CalendarClockIcon, TagIcon, WalletIcon, type LucideIcon } from "lucide-react";

/**
 * The product areas the app is built around.
 *
 * Kept in one place so the header nav and the home page can't drift apart as
 * epics are added — a new epic is a route module plus an entry here.
 */
export type Epic = {
  /** Route path, matching the entry in `src/router.tsx`. */
  path: string;
  /** Short form, for the header nav. */
  label: string;
  title: string;
  description: string;
  Icon: LucideIcon;
};

export const EPICS: Epic[] = [
  {
    path: "/finance",
    label: "Finance",
    title: "Personal finance",
    description: "A monthly income statement, balance sheet and cash flow.",
    Icon: WalletIcon,
  },
  {
    path: "/expiry",
    label: "Expiry",
    title: "Item expiry",
    description: "What you own, when it goes off, and what needs using first.",
    Icon: CalendarClockIcon,
  },
  {
    path: "/prices",
    label: "Prices",
    title: "Item prices",
    description: "What things cost over time, and where they cost least.",
    Icon: TagIcon,
  },
];
